import StockAndPriceData from '../model/stock-and-price-data';

// eslint-disable-next-line import/prefer-default-export
export function pickCheapestVariant(data: StockAndPriceData[]): StockAndPriceData | undefined {
  const withPromo = data.filter((d) => d.sapPromotionPrice);
  if (withPromo.length) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return withPromo.sort((a, b) => a.sapPromotionPrice!.value - b.sapPromotionPrice!.value)[0];
  }
  const withPrice = data.filter((d) => d.sapPrice);
  if (withPrice.length) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return withPrice.sort((a, b) => a.sapPrice!.value - b.sapPrice!.value)[0];
  }
  return data[0];
}
